import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refDownloadDesignProcessPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={'デザインプロセス デザインシステム コンポーネントライブラリ デザイン原則 デザインガイドライン figma'}
          image={'https://www.i3design.jp/ogp_logo.png'}
          url={'https://www.i3design.jp/download/design-process/done/'}
          title="ご入力いただきありがとうございます | デザインプロセス | 資料ダウンロード | i3DESIGN アイスリーデザイン"
          description="ご入力いただいたメールアドレス宛に資料ダウンロード用URLを送付いたしました。メールをご確認いただき、資料をダウンロードしてください。"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
